//import _ from 'lodash';

import * as constants from './MyOrder.constants';
import * as services from './MyOrder.service';

const state = {
  MyOrderList: [],

  isRequest: false,
};

const mutations = {
  [constants.GET_MARKET_TRADE_LIST_SUCCESS](state, MyOrderList) {
    if (undefined !== MyOrderList && null !== MyOrderList) {
      state.MyOrderList = MyOrderList;
    }
  },

  [constants.SET_IS_REQUEST_STATUS](state, data) {
    state.isRequest = data;
  },
};

const actions = {
  async getMarketTradeList({ commit }, payload) {
    commit(constants.SET_IS_REQUEST_STATUS, true);
    try {
      const res = await services.getMarketTradeList(payload);
      if (res.data.data) {
        commit(constants.GET_MARKET_TRADE_LIST_SUCCESS, res.data.data);
      }
    } catch (e) {
      commit(constants.GET_MARKET_TRADE_LIST_SUCCESS, null);
    }
    commit(constants.SET_IS_REQUEST_STATUS, false);
  },
};

const getters = {
  MyOrderList: (state) => state.MyOrderList,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
